import { Search, X } from "lucide-react";

const SCORE_OPTIONS = [
  { value: "all", label: "All scores" },
  { value: "high", label: "High (70+)" },
  { value: "med", label: "Medium (40–69)" },
  { value: "low", label: "Low (<40)" },
];

const EMAIL_OPTIONS = [
  { value: "all", label: "All emails" },
  { value: "verified", label: "Verified" },
  { value: "unverified", label: "Unverified" },
  { value: "unavailable", label: "Not found" },
];

export default function LeadFilterBar({
  query,
  onQueryChange,
  scoreFilter,
  onScoreChange,
  emailFilter,
  onEmailChange,
  total,
  filtered,
}) {
  const hasActive =
    query.trim() !== "" || scoreFilter !== "all" || emailFilter !== "all";

  const onClear = () => {
    onQueryChange("");
    onScoreChange("all");
    onEmailChange("all");
  };

  return (
    <div className="bg-white border border-ink-100 rounded-sm p-3 mb-4 flex items-center gap-3 flex-wrap">
      {/* search */}
      <div className="relative flex-1 min-w-[220px]">
        <Search className="w-3.5 h-3.5 text-ink-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <input
          data-testid="lead-search-input"
          type="text"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Search company, domain, name or email…"
          className="w-full pl-9 pr-3 h-9 rounded-sm border border-ink-200 bg-white text-sm text-ink-900 placeholder:text-ink-400 focus:outline-none focus:border-ink-700 transition-colors"
        />
      </div>

      {/* score filter */}
      <select
        data-testid="lead-score-filter"
        value={scoreFilter}
        onChange={(e) => onScoreChange(e.target.value)}
        className="h-9 px-3 rounded-sm border border-ink-200 bg-white text-xs font-semibold text-ink-700 uppercase tracking-widestx focus:outline-none focus:border-ink-700"
      >
        {SCORE_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>

      {/* email filter */}
      <select
        data-testid="lead-email-filter"
        value={emailFilter}
        onChange={(e) => onEmailChange(e.target.value)}
        className="h-9 px-3 rounded-sm border border-ink-200 bg-white text-xs font-semibold text-ink-700 uppercase tracking-widestx focus:outline-none focus:border-ink-700"
      >
        {EMAIL_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>

      {/* result count */}
      <div
        data-testid="lead-filter-count"
        className="text-[10px] uppercase tracking-widestx font-mono text-ink-400 shrink-0"
      >
        {hasActive ? (
          <>
            <span className="text-ink-900 font-semibold">{filtered}</span> / {total} shown
          </>
        ) : (
          <>{total} total</>
        )}
      </div>

      {hasActive && (
        <button
          data-testid="lead-filter-clear"
          onClick={onClear}
          className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widestx font-semibold text-ink-500 hover:text-ink-900 transition-colors shrink-0"
        >
          <X className="w-3 h-3" />
          Clear
        </button>
      )}
    </div>
  );
}
